import React from "react";

import "./InitialFormStyleSheet.css";
import { s360ConfigService } from "../Services/S360Config";
import {
  DATA_TEST_ID_PREFIX,
  LIVECHAT_CLICK_EVENTS,
} from "../../utils/Constants/statsig.constants";

function InitialFormHeader(props) {
  const onClose = () => {
    if (s360ConfigService.config.sandBox) {
      return;
    }
    // props.actions.setIsAppOpen(false);
    if (typeof props.actions?.onHideChatWindow === "function") {
      props.actions.onHideChatWindow();
    }

    if (s360ConfigService.config?.configDetails?.pendoIntegratedChat) {
      window.parent.postMessage(
        {
          pendoEndChat: "true",
        },
        "*"
      );

      // window.parent.postMessage(
      //   {
      //     minimize: "true",
      //   },
      //   "*"
      // );
    } else {
      window.parent.postMessage(
        {
          minimize: "true",
        },
        "*"
      );
    }
    // props.actions.onStartUpClick();
  };
  return (
    <div
      className="s360-initial-form-header"
      style={s360ConfigService.config?.customDesign?.initialFormHeader}
    >
      <div className="s360-initial-form-header-message">
        <div
          className="s360-initial-form-header-salutation-message"
          style={
            s360ConfigService?.config?.customDesign?.initialFormHeaderMessage
          }
        >
          {/* <h4>{props.config.configDetails?.formMessage}</h4> */}
          <h4>{s360ConfigService.config.configDetails?.brandName}</h4>
          <div
            className="s360-default-header-icon"
            onClick={onClose}
            // style={{
            //   top: s360ConfigService?.config?.configDetails?.pendoIntegratedChat
            //     ? "18px"
            //     : "-6px",
            // }}
            data-testid={`${DATA_TEST_ID_PREFIX}-${LIVECHAT_CLICK_EVENTS.START_UP_WIDGET}`}
          >
            {/* {s360ConfigService.config.configDetails?.pendoIntegratedChat ? (
              <svg
                title="Close conversation"
                width="16"
                height="12"
                viewBox="0 0 12 12"
                fill="none"
                style={{ top: "0px !important" }}
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  style={props.config?.customDesign?.initialFormHeaderIcon}
                  d="M10.7812 2.28125L7.03125 6.03125L10.75 9.75C11.0625 10.0312 11.0625 10.5 10.75 10.7812C10.4688 11.0938 10 11.0938 9.71875 10.7812L5.96875 7.0625L2.25 10.7812C1.96875 11.0938 1.5 11.0938 1.21875 10.7812C0.90625 10.5 0.90625 10.0312 1.21875 9.71875L4.9375 6L1.21875 2.28125C0.90625 2 0.90625 1.53125 1.21875 1.21875C1.5 0.9375 1.96875 0.9375 2.28125 1.21875L6 4.96875L9.71875 1.25C10 0.9375 10.4688 0.9375 10.7812 1.25C11.0625 1.53125 11.0625 2 10.7812 2.28125Z"
                  fill={
                    s360ConfigService.config?.configDetails?.primaryFontColor ??
                    "rgb(1, 95, 235)"
                  }
                />
              </svg>
            ) : (
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="13.624"
                height="53"
                viewBox="0 0 13.624 8.209"
              >
                <path
                  id="down-arrow"
                  d="M2370.983,5063.169a1,1,0,0,1-.73-.316l-5.812-6.209a1,1,0,0,1,1.46-1.367l5.082,5.429,5.082-5.429a1,1,0,0,1,1.46,1.367l-5.812,6.209A1,1,0,0,1,2370.983,5063.169Z"
                  transform="translate(-2364.171 -5054.96)"
                  style={props.config?.customDesign?.initialFormHeaderIcon}
                />
              </svg>
            )} */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="13.624"
              height="53"
              viewBox="0 0 13.624 8.209"
            >
              <path
                id="down-arrow"
                d="M2370.983,5063.169a1,1,0,0,1-.73-.316l-5.812-6.209a1,1,0,0,1,1.46-1.367l5.082,5.429,5.082-5.429a1,1,0,0,1,1.46,1.367l-5.812,6.209A1,1,0,0,1,2370.983,5063.169Z"
                transform="translate(-2364.171 -5054.96)"
                style={props.config?.customDesign?.initialFormHeaderIcon}
              />
            </svg>
          </div>
        </div>
      </div>
    </div>
  );
}

export default InitialFormHeader;
